<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div> 


<div class="columns is-multiline is-gapless is-vcentered"  style="border-bottom:1px solid gray;">

    <div class="column is-12">
        <Calendar :events="data_schedule" :dtStart="dtStart" ></Calendar> 
    </div>

</div><!-- END MAIN COLUMN  -->

</div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import myUtilities from "@/assets/js/utilities.js";



import Calendar from "@/components/Comp_Calendar"

export default {
        props: [ 'type' , 'input_id', 'dat_start'],
        components: {  Calendar  },

        data() {
            return {
                 isLoading:false,
             
                data_schedule:[],
                dtStart: moment().format('YYYY-MM-DD'),

            }
        },
 
    
    created() {



 this.isLoading = true;

var query

if (this.type == 'group') {
    query = `SELECT myMEQ_SCHEDULE_MAIN.*,myMEQ_SCHEDULE_ROOM.schedRoom_DESC,schedRoom_CAMPUS,  MyMEQ_STAFF.staff_Prenom + ' ' + MyMEQ_STAFF.staff_Nom AS prof , DATEADD(day, 1, schedMain_date) AS DateAdd
    FROM myMEQ_SCHEDULE_MAIN LEFT OUTER JOIN myMEQ_SCHEDULE_ROOM ON myMEQ_SCHEDULE_MAIN.schedRoom_ID = myMEQ_SCHEDULE_ROOM.schedRoom_ID LEFT OUTER JOIN  MyMEQ_STAFF ON myMEQ_SCHEDULE_MAIN.staff_ID = MyMEQ_STAFF.staff_ID  
    WHERE myMEQ_SCHEDULE_MAIN.group_id = '` + this.input_id + `' ORDER BY schedMain_AmPmSoir`
} else {
    query = `SELECT myMEQ_SCHEDULE_MAIN.*,myMEQ_SCHEDULE_ROOM.schedRoom_DESC,schedRoom_CAMPUS,  MyMEQ_STAFF.staff_Prenom + ' ' + MyMEQ_STAFF.staff_Nom AS prof , DATEADD(day, 1, schedMain_date) AS DateAdd
    ,MyMEQ_COUR.cour_TITRE_F FROM myMEQ_SCHEDULE_MAIN LEFT OUTER JOIN myMEQ_SCHEDULE_ROOM ON myMEQ_SCHEDULE_MAIN.schedRoom_ID = myMEQ_SCHEDULE_ROOM.schedRoom_ID 
    LEFT OUTER JOIN  MyMEQ_STAFF ON myMEQ_SCHEDULE_MAIN.staff_ID = MyMEQ_STAFF.staff_ID  
    LEFT OUTER JOIN MyMEQ_COURSESTUDENT ON myMEQ_SCHEDULE_MAIN.group_ID = MyMEQ_COURSESTUDENT.group_ID 
    LEFT OUTER JOIN MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID 
    LEFT OUTER JOIN MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID 
    WHERE student_ID = ` + this.input_id + `   ORDER BY schedMain_AmPmSoir`
}



// SET THE START DATE !!!!
this.dtStart = moment(this.dat_start).format('YYYY-MM-DD')

    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 

    var i;
    for (i = 0; i < res.data.length; i++) {

var desc = ''
if (this.check_mobile()) {
    desc = "<div class='columns is-gapless is-multiline'>"
    desc += "<div class='column is-12 is-size-7 has-text-weight-bold'> " + res.data[i].prof + " </div>"
    desc += "<div class='column is-12 is-size-7 has-text-weight-light'> " + res.data[i].schedRoom_CAMPUS + " </div>"
    desc += "<div class='column is-12 is-size-7 has-text-weight-light'> " + res.data[i].schedRoom_DESC  + "</div>"
    desc += "<div>"  
} else {
    desc = "<div class='columns is-gapless is-multiline'>"
    desc += "<div class='column is-12 is-size-6 has-text-weight-bold'> " + res.data[i].prof + " </div>"
    desc += "<div class='column is-9'> " + res.data[i].schedRoom_CAMPUS + " </div>"
    desc += "<div class='column is-3 is-size-5 has-text-weight-bold has-text-centered' style='margin-top:-.5em;'> " + res.data[i].schedRoom_DESC  + "</div>"
    desc += "<div>"    
}






        this.data_schedule.push({ 
            id:res.data[i].schedMain_ID,
            course:res.data[i].cour_TITRE_F,
            title: desc, //res.data[i].schedMain_AmPmSoir + " : " + res.data[i].schedMain_CODE_COUR + " : " + res.data[i].schedMain_CODE_PROF,
            details: 'COUR : ' + res.data[i].schedMain_CODE_COUR + '<br>' + 'PROF : ' + res.data[i].prof + '<br>' + 'TIME : ' + res.data[i].schedMain_AmPmSoir + '<br>SALLE : ' + res.data[i].schedRoom_DESC + '<br><b>' + res.data[i].schedRoom_CAMPUS + '</b>',
            date: moment(res.data[i].DateAdd).format('YYYY-MM-DD'),
            open: false,
            class:'my-event',
            color: res.data[i].schedMain_COLOUR,
            hour:res.data[i].schedMain_AmPmSoir
        })
    } // END FOR 
    }) // END AXIOS
    this.isLoading = false;


    }, // END CREATED


    
methods : {

check_mobile() {
if (sessionStorage.getItem('isMobile') == 'true') 
  {return true} else {return false} 
},



    get_randomKey:function() {
        return myUtilities.randomKey()
    }

}, // END METHODS


}
</script>